import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import Users from '@/views/Users.vue'
import Packages from '@/views/Packages.vue'
import PackageDetails from '@/views/PackageDetails.vue'
import Settings from '@/views/Settings.vue'
import Login from '@/views/Login.vue'
import LockerPage from '@/views/LockerPage.vue'
import Pickup from '@/views/Pickup.vue'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: 'Control units - Community locker admin panel',
      requiresAuth: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      title: 'Users - Community locker admin panel',
      requiresAuth: true
    }
  },
  {
    path: '/packages',
    name: 'Packages',
    component: Packages,
    meta: {
      title: 'Packages - Community locker admin panel',
      requiresAuth: true
    }
  },
  {
    path: '/packages/:order_uuid',
    name: 'PackageDetails',
    component: PackageDetails,
    meta: {
      title: 'Package details - Community locker admin panel',
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      title: 'Settings - Community locker admin panel',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login - Community locker admin panel'
    }
  },
  {
    path: '/locker/:uuid',
    name: 'LockerPage',
    component: LockerPage,
    meta: {
      title: 'Community Locker - Locker page',
      requiresAuth: false
    }
  },
  {
    path: '/locker/pickup/:code',
    name: 'Pickup',
    component: Pickup,
    meta: {
      title: 'Community Locker - Pickup page',
      requiresAuth: false
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '404 - Not Found',
      requiresAuth: false
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // Update page title
  document.title = to.meta.title || 'Community locker admin panel'
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router 